/**
 * Dumb renderer for service/items/geometry errors.
 */

import React from "react";
import Typography from "@mui/material/Typography";

export default function ErrorsPanel({
  servicesError,
  servicesErrorText,
  itemsError,
  itemsErrorText,
  geometryError,
  geometryErrorText,
}) {
  return (
    <>
      {servicesError && (
        <Typography data-cy="services-error-panel" color="error" style={{ marginBottom: 10 }}>
          {servicesErrorText}
        </Typography>
      )}

      {itemsError && (
        <Typography color="error" style={{ marginBottom: 10 }}>
          {itemsErrorText}
        </Typography>
      )}

      {geometryError && (
        <Typography color="error" style={{ marginBottom: 10 }}>
          {geometryErrorText}
        </Typography>
      )}
    </>
  );
}
